import type { Slots, StepForm } from '@types'
import { useMemo } from 'react'

interface Params {
  data: StepForm
  date: any
  slots: Slots
  timeFieldName: string
}

export function useQuestionsBySlots({ data, date, slots, timeFieldName }: Params) {
  const questions = useMemo(() =>
    data
      .filter((question) => {
        if (!date || !slots?.[date]) {
          return question.db_field_name !== timeFieldName
        } else {
          return true
        }
      })
      .map((question) => {
        if (question.db_field_name === timeFieldName) {
          return ({
            ...question,
            options: slots?.[date]
              ?.filter((slot) => slot.team !== 'Booked')
              ?.map((slot) => ({
                item: slot.time_display,
                db_item_name: JSON.stringify(slot),
                min: '',
                max: ''
              }))
          })
        } else {
          return question
        }
      })
  , [date, slots])

  return questions
}
